module.exports = __webpack_public_path__ + "5a633a62dddde37c9f998b0fbd12d272.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/symbol-list/download.svg
// module id = 226
// module chunks = 0